import * as actionTypes from "../actions/WorkspaceApiExposureActions";

const initialState = {
  Loading: false,
  
  workspaceApiExpoureList: [],
 
  
  workspaceApiExposureRecord: [],
  workspaceApiExposureDropdownList: [],
 
  validation_error: "",
  
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal:false,
  session: null, // Add session state
};
const WorkspaceApiExposureReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WORKSPACE_API_EXPOSURE_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };
  
    
    case actionTypes.WORKSPACE_API_EXPOSURE_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        workspaceApiExpoureList: action.workspaceApiExpoureList,
        showUpdateForm: false,
        showViewPage: false,
        workspaceApiExposureRecord: [],
      };

    case actionTypes.WORKSPACE_API_EXPOSURE_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        workspaceApiExposureRecord: [],
      };
    case actionTypes.WORKSPACE_API_EXPOSURE_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        workspaceApiExposureRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.WORKSPACE_API_EXPOSURE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        workspaceApiExposureDropdownList: action.workspaceApiExposureDropdownList,
      };
    case actionTypes.HIDE_WORKSPACE_API_EXPOSURE_FEILD_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_WORKSPACE_API_EXPOSURE_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_WORKSPACE_API_EXPOSURE_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        workspaceApiExposureRecord: [],
      };

   

    default:
      return state;

   
  }
};

export default WorkspaceApiExposureReducer;
